(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brands-block"] && !Shopify.designMode) return;
  try {
    
function process_slick_event(evt) {
      var carousel_brand = $('[data-owl]');
      if (carousel_brand.length) {
         carousel_brand.each(function(index, el) {
            $(this).owlCarousel($(this).data('owl'));
         });
	  }
}    
$(document)
 .on( 'shopify:section:load', process_slick_event )
 .on( 'shopify:section:unload', process_slick_event )
;

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
function process_slick_event(evt) {
  var _slick = $( "#" +evt.target.id + " .sale_of");
  if( _slick.length )
  {
    switch ( evt.originalEvent.type ) {
      case "shopify:section:load" : 
        console.log('Load ' + _slick.attr("id"));
        _slick.slick (
            {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                vertical: true,
                autoplay: true,
                prevArrow: false,
                nextArrow: false
            }
          );
      break; 
      case "shopify:section:unload" :
        console.log('Unload ' + _slick.attr("id"));
        _slick.slick('unslick');
      break;

     } 
  }
}
    
$(document)
 .on( 'shopify:section:load', process_slick_event )
 .on( 'shopify:section:unload', process_slick_event )
;


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-featured-collection"] && !Shopify.designMode) return;
  try {
    
function process_owl_event(evt) {
      var  carousel_pro = $('[data-owl-carousel]');
	  carousel_pro = $('.widget-product .product_scroll'); 
      if (carousel_pro.length) {
         carousel_pro.each(function(index, el) {
            $(this).owlCarousel($(this).data('owl-carousel'));
         });
	  }
}

process_owl_event();

$(document)
 .on( 'shopify:section:load', process_owl_event )
 .on( 'shopify:section:unload', process_owl_event )
;

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
function process_slick_event(evt) {
  var _slick = $( "#" +evt.target.id + " .home-slider-wrap .hero-slides");
  if( _slick.length )
  {
    switch ( evt.originalEvent.type ) {
      case "shopify:section:load" : 
        console.log('Load ' + _slick.attr("id"));
        _slick.slick (
            {
             centerMode: true,
              variableWidth: true,
              centerPadding: '60px',
              slidesToShow: _slick.data('slick').slidesToShow,
              slidesToScroll: 1,
              autoplay: _slick.data('slick').autoplay,
              autoplaySpeed: _slick.data('slick').autoplaySpeed
            }
          );
      break; 
      case "shopify:section:unload" :
        console.log('Unload ' + _slick.attr("id"));
        _slick.slick('unslick');
      break;

     } 
  }
}
    
$(document)
 .on( 'shopify:section:load', process_slick_event )
 .on( 'shopify:section:unload', process_slick_event )
;


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["test"] && !Shopify.designMode) return;
  try {
    

function process_slick_event(evt) {
  var _slick = $( "#" +evt.target.id + " .product-slider");
  if( _slick.length )
  {
    switch ( evt.originalEvent.type ) {
      case "shopify:section:load" : 
        console.log('Load ' + _slick.attr("id"));
        _slick.slick (
            {
              slidesToShow: _slick.data('slick').slidesToShow,
              slidesToScroll: 1,
              autoplay: _slick.data('slick').autoplay,
              autoplaySpeed: _slick.data('slick').autoplaySpeed
            }
          );
      break; 
      case "shopify:section:unload" :
        console.log('Unload ' + _slick.attr("id"));
        _slick.slick('unslick');
      break;

     } 
  }
}
    
$(document)
 .on(   'shopify:section:load', process_slick_event )
 .on( 'shopify:section:unload', process_slick_event )
;


  } catch(e) { console.error(e); }
})();
})();
